import React, { useState } from "react";
import Sidebar from "../../common/components/Sidebar/sidebar";

import FormHeader from "../../common/components/FormHeader/FormHeader";
import DataForm from "../../common/components/dataEntryFormComponent/DataForm";
import Strings from "../../common/res/String";
import { useLocation } from "react-router-dom";
import RightSidebar from "../../common/components/RightSidebar/RightSidebar";
import TimeLine from "../../common/components/TimeLine/TimeLine";
import DataEntryEditForm from "../../common/components/dataEntryFormComponent/DataEntryEditForm";
import FormPage from "../../common/components/dataEntryFormComponent/FormPage";
import NewDataForm from "../../common/components/dataEntryFormComponent/NewDataForm";
import PopUpModal from "../../common/components/popupmodal/PopUpModal";
// import logo from "../../assets/img/timber_logo.png";
import logo from "../../common/assets/img/timber_logo.png";
import { useDispatch, useSelector } from "react-redux";
import { pl } from "../../common/Redux/Actions";
import PLPassword from "../../common/components/plPassword/PLPassword";
export default function DataEntryForm() {
  const { state } = useLocation();
  const [isCount, setIsCount] = useState(1);
  const [showFileName, setShowFileName] = useState(null);

  const dispatch = useDispatch();
  const [showPasswordPrompt, setShowPasswordPrompt] = useState(false);

  return (
    <>
      <div className="container-fluid">
        <div className="row">
          {/* Sidebar: Always visible on all screen sizes, but width changes */}
          <div className="col-12 col-md-3 col-lg-2 p-0">
            <Sidebar />
          </div>

          {/* Main Content Area */}
          <div className="col-12 col-md-9 col-lg-10 p-0">
            {state !== null ? (
              <>
                {/* Timeline Header (visible on top) */}
                <div className="row align-items-center">
                  <div className="col-12 px-4 px-md-5">
                    <TimeLine currentStep={isCount} />
                  </div>
                </div>

                {/* Main Form & Right Sidebar */}
                <div className="row px-3 px-md-5">
                  <div className="col-12 col-lg-9 pt-2">
                    <div className="dataEntryMainContainer --copydocument">
                      <FormHeader
                        header={Strings.data_entry}
                        showFileName={showFileName}
                      />
                      <div className="data-entry-form-block">
                        <NewDataForm
                          showFileName={showFileName}
                          setShowFileName={setShowFileName}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-lg-3 p-0 mt-3 mt-lg-0 right_col">
                    <RightSidebar
                      setIsCount={setIsCount}
                      islabel="COPY DOCUMENT"
                      setShowPasswordPrompt={setShowPasswordPrompt}
                    />
                  </div>
                </div>
              </>
            ) : (
              // Fallback form for null state
              <div className="col-12 col-sm-10 col-lg-10 offset-sm-1 mt-3 mb-4 p-3">
                <div className="dataEntryMainContainer">
                  <FormHeader
                    header={Strings.data_entry}
                    showFileName={showFileName}
                  />
                  <div className="data-entry-form-block">
                    <NewDataForm
                      showFileName={showFileName}
                      setShowFileName={setShowFileName}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <PLPassword />
    </>
  );
}
